import api from '@pray/shared/utils/api';

// DELETE …/campaigns/recurring-push/:id/audiences/:audienceId responds 204 No Content.
// Allowed on draft + active + stopped; the server is the real guard.
export async function removeRecurringPushAudience({
  artistId,
  recurringCampaignId,
  audienceId,
}: {
  artistId: string;
  recurringCampaignId: string;
  audienceId: string;
}): Promise<void> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');
  if (!audienceId) throw new Error('Audience ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring-push/${recurringCampaignId}/audiences/${audienceId}`;
  await api.executeDeleteRequest<void>(url);
}
